module.exports = __webpack_public_path__ + "img/bg_home.ae8d6ba7.png";